import { ConfirmationLineTable } from "./ConfirmationLineTable";
import type { ConfirmationCategoryTableProps, ConfirmationTableColumn } from "./tableTypes";

/** 独立维护火车路线、车次、席别和角色的表格展示。 */
export function ConfirmationTrainTable({ common, table }: ConfirmationCategoryTableProps) {
  const { item, date, role, quantity, count, price, amount, provider, tail } = common;
  const columns: ConfirmationTableColumn[] = [{ ...item, label: "路线 / 车次 / 席别", width: 240 }, date, { ...role, width: 78 }, quantity("人数"), count("次数"), price, amount, provider, ...tail];
  return <ConfirmationLineTable {...table} columns={columns} variant="train" />;
}
